import React from "react";
import OperationalStepList from "./OperationalStepList.jsx";
import { joinClasses } from "./ResultsPrimitives.jsx";

export default function TripGroup({ group, interactions = {} }) {
  return (
    <section
      className={joinClasses(["grid gap-1"]) }
      data-assignment-trip-group
      data-trip-id={group.tripId}
    >
      <OperationalStepList
        interactions={interactions}
        steps={group.operationalSteps}
      />
    </section>
  );
}
